module.exports = __webpack_public_path__ + "static/media/alligator_ladies_strap_black.0710d536.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alligator_ladies_strap_black.png
// module id = 123
// module chunks = 0